import z, { SafeParseError } from "zod";

const isNum = (v: string) => {
  const testingValue = Number(v);
  if (!isNaN(testingValue)) {
    return true;
  }
};
function hasDecimal(num: string) {
  if (num.split(".").length > 1) {
    return true;
  }
}
const NUMBER_ERROR_MESSAGE = "Must be a number";
const modifierValidation = z
  .preprocess((x) => {
    return Math.abs(Number(x)).toString();
  }, z.string())
  .refine(
    (v) => {
      return isNum(v);
    },
    { message: NUMBER_ERROR_MESSAGE }
  )
  .refine(
    (v) => {
      return /^\d+(?:\.\d{1,4})?$/.test(v);
    },
    { message: "Max precision is 4 decimals" }
  );

const multiplierValidation = z
  .string()
  .refine((v: string) => isNum(v) && !hasDecimal(v), {
    message: `${NUMBER_ERROR_MESSAGE} and contain no decimal points`,
  });
function handleZodError(p: SafeParseError<string>) {
  return !p.error.isEmpty && p.error?.errors?.[0].message;
}
export { modifierValidation, multiplierValidation, handleZodError };
